import permissions from '@/config/permissions';

export default prop => Object.keys(permissions).reduce((obj, key) => ({ ...obj, [key]: permissions[key][prop] }), {});
